'use strict';

var Backbone    = require('backbone');
var $           = require('jquery');
var URI         = require('urijs');

module.exports = Backbone.View.extend({

    el: '.nav-bar-wrapper',

    /**
     * Set all the events and other helpers
     */
    initialize: function () {

        var self = this;

        this.ui.navSearchInput.keypress(self.doSearch);

        this.render();

    },

    /**
     * Set all the logic that needs to run when the form is shown
     */
    render: function () {

        // let allowedPages = {
        //     '/company': true,
        //     '/person': true
        // };
        //
        // let url = URI.parse(window.location.href);
        //
        // if (!allowedPages[url.path]) {
        //     this.ui.navSearch.remove();
        // }

    },

    /**
     * Register all the ui elements used in this form
     */
    ui: {
        navSearch:          $('.nav-search'),
        searchIcon:         $('.search-icon'),
        navSearchInput:     $('.nav-search-input')
    },

    /**
     * Register all the events to handle this form
     */
    events: {
        'click #nav-click':     'toggleSubMenu',
        'click .search-icon':   'showSearchInput'
    },

    showSearchInput: function (e) {

        e.preventDefault();

        this.ui.navSearch.toggleClass('open');
        this.ui.navSearchInput.focus();

    }

    // doSearch: function (event) {

    //     var keycode = (event.keyCode ? event.keyCode : event.which);
    //     if (keycode === 13) {
    //         // Parse the current query string
    //         var params = [],
    //             columnName = 'id',
    //             sortBy = 'asc';

    //         params.push('page=1');
    //         params.push('column_name=' + columnName);
    //         params.push('sort_by=' + sortBy);
    //         params.push('search_by=' + $('.nav-search-input').val());

    //         window.location.href = window.location.pathname + '?' + params.join('&');
    //     }
    // }

});
